var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvgScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28571 29.7143V17.1429H4.57143V14.8571H2.28571V0H0V29.7143C0 30.3205 0.240816 30.9019 0.66947 31.3305C1.09812 31.7592 1.67951 32 2.28571 32H32V29.7143H2.28571Z",
    fill: "#0923E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85714 14.8571H9.14286V17.1429H6.85714V14.8571ZM11.4286 14.8571H13.7143V17.1429H11.4286V14.8571ZM20.5714 14.8571H22.8571V17.1429H20.5714V14.8571ZM25.1429 14.8571H27.4286V17.1429H25.1429V14.8571ZM29.7143 14.8571H32V17.1429H29.7143V14.8571Z",
    fill: "#0923E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.8571H18.2857V17.1429H16V14.8571ZM20.5714 14.8571H22.8571V17.1429H20.5714V14.8571ZM29.7143 14.8571H32V17.1429H29.7143V14.8571Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgScore);
export default __webpack_public_path__ + "static/media/Avg-score.6548b00d585329f0297a7cc2ead8f04c.svg";
export { ForwardRef as ReactComponent };